// extracted by mini-css-extract-plugin
export default {"confirmationContent":"IssueDeletionConfirmationDialog-module__confirmationContent--iOcR3","confirmationList":"IssueDeletionConfirmationDialog-module__confirmationList--inbpU"};